import { Tab, Tabs, useMediaQuery } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { DefaultSetting, TabDefaultSetting } from '../../layoutPages/defaultSetting';
import { MenuButtonData } from '../../system/Classes/MenuButtonData';
import { setSubjectMenuTabIdx } from '../../system/Slicer/CommonSlicer';
import { selectComponentStore } from '../../system/PageStore';



interface CourseTabProps {
    data?: Array<MenuButtonData>;
    nowIndex?: number; //Elroy, fix this hard code!! //Good job Elroy!
}

export function CourseTab(props: CourseTabProps) {
    const isPc = useMediaQuery('(min-width:600px)');
    const navigate = useNavigate();
    const componentStates = useSelector(selectComponentStore);
    const dispatch = useDispatch();

    return (
        <Tabs
            value={props.nowIndex ?? componentStates.CommonComponentReducer.subjectMenuTabIndex}
            //onChange={() => { }}
            variant={isPc ? "fullWidth" : "scrollable"}
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
                bgcolor: { xs: "transparent", sm: TabDefaultSetting.bgColor },
                borderRadius: { xs: 0, sm: "5px" },
                mb: 1.5,
                px: { xs: 1, sm: 0 },
                py: { xs: 0.75, sm: 0 },
                minHeight: { xs: "44px", sm: "48px" },
                "& .MuiTabs-flexContainer": {
                    gap: { xs: 0.75, sm: 0 },
                },
                "& .MuiTabs-indicator": {
                    display: { xs: "none", sm: "block" },
                    backgroundColor: DefaultSetting.mainColor,
                },
                "& .MuiTabs-scrollButtons": {
                    color: DefaultSetting.mainColor,
                    width: { xs: "24px", sm: "40px" },
                },
            }}
        >
            {props.data && props.data.map((item, index) => (
                <Tab
                    key={index}
                    sx={{
                        textTransform: "none",
                        minHeight: { xs: "38px", sm: "48px" },
                        minWidth: { xs: "auto", sm: 0 },
                        px: { xs: 1.5, sm: 1 },
                        py: { xs: 0.75, sm: 1 },
                        borderRadius: { xs: "999px", sm: 0 },
                        border: { xs: "1px solid #D6E8F8", sm: 0 },
                        bgcolor: { xs: "#FFFFFF", sm: "transparent" },
                        color: DefaultSetting.subContentColor,
                        fontSize: { xs: "0.9rem", sm: TabDefaultSetting.tabTextSize },
                        boxShadow: { xs: "0 2px 8px rgba(41, 131, 204, 0.12)", sm: "none" },
                        "&.Mui-selected": {
                            bgcolor: { xs: DefaultSetting.mainColor, sm: "transparent" },
                            color: { xs: "#FFFFFF", sm: DefaultSetting.mainColor },
                            borderColor: DefaultSetting.mainColor,
                        },
                    }}
                    label={item.display}
                    onClick={() => { dispatch(setSubjectMenuTabIdx(index)); navigate(item.path); }}
                />
            ))}
        </Tabs>
    );
}

